import CityPageTemplate from "../city-template/CityPageTemplate";
import { longviewConfig } from "./data";

export default function LongviewPage() {
  return <CityPageTemplate config={longviewConfig} />;
}